/**
 * Enumération définissant les thématiques existantes et protégées
 */
enum THEMATIQUE {
  OLDEBS = "OLDEBS",
  PERMIS = "PERMIS",
  RCI = "RCI",
  DFCI = "DFCI",
  SIGNALEMENT = "SIGNALEMENT",
  RISQUES = "RISQUES",
  DIVERS = "DIVERS",
  CARTOGRAPHIE_PERSONNALISEE = "CARTOGRAPHIE_PERSONNALISEE",
  POINT_EAU = "POINT_EAU",
  COUVERTURE_HYDRAULIQUE = "COUVERTURE_HYDRAULIQUE",
}
export default THEMATIQUE;
